// assessment-accounts-modal.component.ts
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';

export interface AssessmentAccount {
  assessmentUnitId: string;
  name: string;
  customerGroup?: string;
  accountId?: string;
}

@Component({
  selector: 'app-assessment-accounts-modal',
  templateUrl: './assessment-modal.component.html',
  styleUrls: ['./assessment-modal.component.css']
})
export class AssessmentModalComponent implements OnInit {

  assessmentAccounts: AssessmentAccount[] = [];

  // Optional callback or event emitter could be here if needed to handle selection
  public onClose: Subject<string> = new Subject();

  constructor(public bsModalRef: BsModalRef, private storageService: StorageService) { }

  ngOnInit(): void { }

  chooseAssessment(account: AssessmentAccount) {
    // console.log('Selected account:', account);
    let preselectedAccount: any = this.storageService.getSessionStorageData('selectedAccount');
    // console.log("preselectedAccount ", preselectedAccount?.assessmentUnitId)
    if (account.assessmentUnitId != preselectedAccount?.assessmentUnitId) {
      this.storageService.setSessionStorageData('selectedAccount', account);
      this.onClose.next(account.assessmentUnitId);
    }
    this.bsModalRef.hide();
  }
}
